import React from 'react';
import './CollapseIcon.scss';

interface CollapseIconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export const CollapseIcon: React.FC<CollapseIconProps> = ({ className = '', size = 24, strokeWidth = 2.5 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`collapse-icon ${className}`}
    >
      <path
        d="M5 12H19"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};
